import React from "react";
import {IProduct} from 'data/interfaces/products';
import AdRoomSize
  from 'gui/components/listPage/components/ad/components/adRoomSize';
import AdMealType
  from 'gui/components/listPage/components/ad/components/adMealType';
import AdHotelWebsite
  from 'gui/components/listPage/components/ad/components/adHotelWebsite';
import AdRoomsAmount
  from 'gui/components/listPage/components/ad/components/adRoomsAmount';
import AdArrivalDate
  from 'gui/components/listPage/components/ad/components/adArrivalDate';
import AdLeaveDate
  from 'gui/components/listPage/components/ad/components/adLeaveDate';
import AdInfo from 'gui/pages/mainRouter/pages/ad/components/commons/adInfo';
import AdHotelGoogleScore from "gui/components/listPage/components/ad/components/adHotelGoogleScore/AdHotelGoogleScore";


export interface IHotelInfoProps {
  product: IProduct;
  className?: string;
  title?: string;
  hideTitle?: boolean;
  additionalDetails?: any;
}

const HotelInfo = (props: IHotelInfoProps) => props.product.hotelDetails ? (
  <AdInfo {...props}>
    <AdArrivalDate
      startDate={props.product.hotelDetails.checkInDate}
    />
    <AdLeaveDate
      endDate={props.product.hotelDetails.checkOutDate}
    />
    <AdRoomSize
      people={props.product.hotelDetails.roomPeopleAmount}
    />
    <AdRoomsAmount
      roomsAmount={props.product.hotelDetails.roomsAmount}
    />
    <AdMealType product={props.product}/>
    <AdHotelGoogleScore hotelDetails={props.product.hotelDetails}/>
    <AdHotelWebsite hotelDetails={props.product.hotelDetails}/>
    {props.additionalDetails}
  </AdInfo>
) : null;

HotelInfo.defaultProps = {
  product: {},
  title: 'מידע:',
  className: '',
  additionalDetails: null,
};

export default HotelInfo;
